<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    // Whether the options are visible or not.
    isOpen: false,
  }),

  methods: {
    toggle() {
      this.isOpen = !this.isOpen
    },
    show() {
      this.isOpen = true
    },
    hide() {
      this.isOpen = false
    },
    // Set option as selected state and close dropdown.
    set(option) {
      this.selected = option
      this.hide()
    },
    hideMenu() {
      if (this.isOpen) {
        this.isOpen = false
      }
    },

    async logout() {
      // Log out the user.
      await this.$store.dispatch('auth/logout')
      window.location = config.public_url
    },
  },
}
</script>
<template>
  <div class="my-dropdown">
    <div
      v-click-outside="hideMenu"
      class="selected"
      @click="toggle"
    >
      {{ name }} &nbsp;&nbsp;
      <img
        class="user-profile-icon"
        src="/images/down-arrow-white.svg"
      >
    </div>
    <div
      v-show="isOpen"
      class="options"
    >
      <div class="option">
        <router-link :to="{ name: 'profile' }">
          Profile
        </router-link>
      </div>
      <div class="option">
        <a
          href="https://support.zendrop.com"
          target="_blank"
        >
          Support
        </a>
      </div>
      <div class="option">
        <a
          href="#"
          @click.prevent="logout"
        >
          Logout
        </a>
      </div>
    </div>
  </div>
</template>
